"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var form_field_1 = require("@material/form-field");
var radio_1 = require("@material/radio");
// @ts-ignore
var util_ts_1 = require("../util.ts");
//@ts-ignore
require("../theme.ts");
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function () {
            if (_this.props.disabled)
                return;
            _this.group.forEach(function (item) {
                item.radio.checked = false;
            });
            var pre = _this.radio.checked;
            if (!pre) {
                _this.radio.checked = true;
                _this.fire('selected', { value: _this.props.value });
            }
        };
        return _this;
    }
    Radio.prototype.installed = function () {
        var _this = this;
        var radio = new radio_1.MDCRadio(this.shadowRoot.querySelector('.mdc-radio'));
        var formField = new form_field_1.MDCFormField(this.shadowRoot.querySelector('.mdc-form-field'));
        formField.input = radio;
        this.radio = radio;
        this.group = this.getScopeRoot(this.shadowRoot.host).querySelectorAll("m-radio[name='" + this.props.name + "']");
        //fix group 不一致
        this.group.forEach(function (ele) {
            ele.group = _this.group;
        });
    };
    Radio.prototype.render = function (props) {
        return (omi_1.h("div", __assign({ onClick: this.clickHandler }, omi_1.extractClass(props, 'mdc-form-field', {
            'mdc-checkbox--disabled': props.disabled
        })),
            omi_1.h("div", { class: omi_1.classNames('mdc-radio', {
                    'mdc-radio--disabled': props.disabled
                }) },
                omi_1.h("input", __assign({ type: "radio" }, util_ts_1.extract(props, ['checked', 'value', 'disabled']), { class: "mdc-radio__native-control", id: "radio" })),
                omi_1.h("div", { class: "mdc-radio__background" },
                    omi_1.h("div", { class: "mdc-radio__outer-circle" }),
                    omi_1.h("div", { class: "mdc-radio__inner-circle" }))),
            omi_1.h("label", { for: "radio" }, props.label)));
    };
    Radio.prototype.getScopeRoot = function (current) {
        while (true) {
            var p = current.parentNode;
            if (p) {
                current = p;
            }
            else {
                return current;
            }
        }
    };
    Radio.css = css;
    Radio.propTypes = {
        label: String,
        disabled: Boolean,
        checked: Boolean,
        value: String,
        name: String
    };
    Radio = __decorate([
        omi_1.tag('m-radio')
    ], Radio);
    return Radio;
}(omi_1.WeElement));
